module.exports = __webpack_public_path__ + "static/media/living_room.7342732b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/living_room.svg
// module id = 1891
// module chunks = 0